import React, { useState } from 'react'
import { Oval } from 'react-loader-spinner'
import { useLocation, useNavigate } from 'react-router-dom';
import "./ChangePassword.scss"
import Laptop from "../../assets/img/laptop.png"

function ChangePassword() {

    const navigate = useNavigate();

    const { state } = useLocation();

    const [visible, setVisible] = useState(false)
    const [visibleTwo, setVisibleTwo] = useState(false)

    const [errors, setErrors] = useState({})
    const [error, setError] = useState(null)

    const [pass, setPass] = useState({
        newPass: "",
        repeatPass: ""
    })

    const [loading, setLoading] = useState(false)

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPass({
            ...pass,
            [name]: value,
        })
    }

    const validate = (data) => {
        const errors = {}
        // new password
        if(!data.newPass.trim()) {
            errors.newPass = "Escriba la nueva contraseña."
        } else if (!/^(?=.*[A-Z])(?=.*\d)(?=.{8,})/.test(data.newPass)){
            errors.newPass = "La contraseña debe contener una mayúscula, un símbolo y un número."
        } else if (data.newPass !== data.repeatPass){
            errors.newPass = "Las contraseñas no coinciden."
        }
        // confirm password
        if(!data.repeatPass.trim()) {
            errors.repeatPass = "Repita la nueva contraseña."
        } else if (data.newPass !== data.repeatPass){
            errors.repeatPass = "Las contraseñas no coinciden."
        }
        return errors;
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const newErrors = validate(pass)
        setErrors(newErrors)
        if(Object.keys(newErrors).length === 0){
            setError(null)
            const obj = {
                mailUser: state.email,
                newPasword: pass.newPass,
                newPaswordValidator: pass.repeatPass
            }
            try {
                setLoading(true)
                const res = await fetch(`${process.env.REACT_APP_API_URL}/apis/user/recupera/recuperarPass`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(obj)
                })
                const data = await res.json()
                const codeError = data.error ?? data.status
                if(codeError !== 0){
                    setError(data.errorDetalle || data.codeError)
                } else {
                    const data = {
                        codigo : 0,
                        mail: state.email
                    }
                    navigate("/", {state: data})
                }
            } catch (error) {
                setError("Error: Conexión con backend.")
            } finally {
                setLoading(false)
            }
        } else {
            setError("Completar los campos mencionados.")
        }
    }

    return (
        <>
            {loading && <div className='loading__changePassword' role='status'>
                    <Oval
                        visible={true}
                        height="80"
                        width="80"
                        color="#fff"
                        ariaLabel="oval-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                    />
                    <p className='text-white fw-medium'>Loading...</p>
                </div>
            }
            <div className='changePassword vh-100 d-flex align-items-center justify-content-center'>
                <div className='changePassword__form bg-white d-flex flex-column align-items-center justify-content-center shadow-sm rounded-3'>
                    <img className='mb-4' src={Laptop} alt='Usuario'/>
                    <h3 className='text-blue-500 fw-medium text-center mb-5'>Ingresa una nueva contraseña</h3>
                    <form className='w-100 d-flex flex-column align-items-center' onSubmit={handleSubmit}>
                        {/* New password */}
                        <div className='w-100 d-flex flex-column mb-3'>
                            <label htmlFor="password" className='form-label'>Nueva contraseña</label>
                            <div className='d-flex flex-row align-items-center input--fake'>
                                <input 
                                    onChange={handleChange} 
                                    type={visible ? "text" : "password"}
                                    id='newPass' 
                                    name="newPass" 
                                    placeholder='' 
                                    className='form-control input--none border-0'
                                    value={pass.newPass}
                                    autoFocus
                                />
                                <div className='input--icon' onClick={()=>setVisible(!visible)}>
                                    {visible ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                                </div>
                            </div>
                            {errors.newPass && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.newPass}</span>}
                        </div>
                        {/* Confirm password */}
                        <div className='w-100 d-flex flex-column mb-4'>
                            <label htmlFor="password" className='form-label'>Repetir contraseña</label>
                            <div className='d-flex flex-row align-items-center input--fake'>
                                <input 
                                    onChange={handleChange} 
                                    type={visibleTwo ? "text" : "password"}
                                    id='repeatPass' 
                                    name="repeatPass" 
                                    placeholder='' 
                                    className='form-control input--none border-0'
                                    value={pass.repeatPass}
                                />
                                <div className='input--icon' onClick={()=>setVisibleTwo(!visibleTwo)}>
                                    {visibleTwo ? <i className="bi bi-eye-slash"></i> : <i className="bi bi-eye"></i>}
                                </div>
                            </div>
                            {errors.repeatPass && <span className='form__error d-flex flex-row align-items-center px-1 my-1'><i className="bi bi-exclamation-circle me-1"></i>{errors.repeatPass}</span>}
                        </div>
                        {error !== null && <div className='mb-2 form__error'><i className="bi bi-exclamation-circle pe-2 text-danger"></i><span className='text-danger'>{error}</span></div>}
                        <button type='submit' className='btn btn-primary rounded-pill fw-medium px-4'>Cambiar contraseña</button>
                    </form>
                </div>
            </div>
        </>
    )
}

export default ChangePassword